import { bolAwbLabels } from '../../text'

const fieldTypes = {
  master: true,
  intAsString: true,
  epoch: true,
  string: true,
  enum: true,
  boolean: true
}

const validateNumber = value => {
  let len = value.length
  if (len === 0) return false
  else if (len > 0 && len === 11) {
    if (
      !!value.substring(0, 4).match('^[a-zA-Z]+$') &&
      !!value.substring(4, 11).match('^[0-9]+$')
    ) {
      return true
    }
  }
  return false
}

export const bolAwbFields = {
  nonAms: {
    id: 'nonAms',
    label: bolAwbLabels.nonAms,
    apiKey: 'nonAms',
    type: fieldTypes,
    rules: [],
    errors: [],
    valid: true
  },
  splitBill: {
    id: 'splitBill',
    label: bolAwbLabels.splitBill,
    apiKey: 'splitBill',
    type: fieldTypes,
    rules: [],
    errors: [],
    valid: true
  },
  itNumber: {
    id: 'itNumber',
    label: bolAwbLabels.itNumber,
    apiKey: 'itNumber',
    type: fieldTypes,
    rules: [],
    errors: [],
    valid: true
  },
  itDate: {
    id: 'itDate',
    label: bolAwbLabels.itDate,
    apiKey: 'itDate',
    type: fieldTypes,
    rules: [],
    errors: [],
    valid: true
  },
  locationOfGoods: {
    id: 'locationOfGoods',
    label: bolAwbLabels.locationOfGoods,
    apiKey: 'locationOfGoods',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  centralizedExaminationSite: {
    id: 'centralizedExaminationSite',
    label: bolAwbLabels.centralizedExaminationSite,
    apiKey: 'centralizedExaminationSite',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== '' || true//UB-812 remove this validation
        },
        message: 'No CES was specified'
      }
    ],
    errors: [],
    valid: true
  },
  boltype: {
    id: 'boltype',
    label: bolAwbLabels.boltype,
    apiKey: 'boltype',
    type: fieldTypes,
    rules: [],
    errors: [],
    valid: true
  },
  bolnumber: {
    id: 'bolnumber',
    label: bolAwbLabels.bolnumber,
    apiKey: 'bolnumber',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  bolHouseNumber: {
    id: 'bolHouseNumber',
    label: bolAwbLabels.bolnumber,
    // apiKey: 'bolnumber',
    type: fieldTypes,
    rules: [
    ],
    errors: [],
    valid: true
  },
  'manifestQuantity.Quantity': {
    id: 'manifestQuantity.Quantity',
    label: 'MANIFEST QUANTITY',
    apiKey: 'manifestQuantity.quantity',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  'manifestQuantity.Units': {
    id: 'manifestQuantity.Units',
    label: 'MANIFEST QUANTITY',
    apiKey: 'manifestQuantity.units',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== '_BLANK_'
        },
        message: 'unit required'
      }
    ],
    errors: [],
    valid: true
  }
}

for (let i = 0; i < 30; i++) {
  bolAwbFields['number' + i] = {
    rules: [
      {
        test: value => {
          return validateNumber(value)
        },
        message: 'Container number was invalid. The value was not saved, please amend. Should be of format [A-Z]{4}[0-9]{7}'
      }
    ],
    errors: [],
    valid: true
  }
}

for (let i = 0; i < 30; i++) {
  bolAwbFields['size' + i] = {
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  }
}
for (let i = 0; i < 5; i++) {
  bolAwbFields['sealNumber' + i] = {
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      },
      {
        test: value => {
          return true
        },
        message: 'Invalid container sealNumber'
      }
    ],
    errors: [],
    valid: true
  }
}
for (let i = 0; i < 5; i++) {
  bolAwbFields['quantity' + i] = {
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      },
      {
        test: value => {
          return !isNaN(parseFloat((value)))
        },
        message: 'Invalid container quantity'
      }
    ],
    errors: [],
    valid: true
  }
}
for (let i = 0; i < 5; i++) {
  bolAwbFields['weight' + i] = {
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      },
      {
        test: value => {
          return !isNaN(parseFloat((value)))
        },
        message: 'Invalid container weight'
      }
    ],
    errors: [],
    valid: true
  }
}
